import React, { Component, Fragment } from 'react';
import ReactHtmlParser from 'react-html-parser';

import checkForm from '../images/check-form.svg';
import '../style/prevBriefing.scss';
import api from '../../../services/api';
import { useHistoryPush } from '../../../services/hooks/UseHistoryPush';

import { BriefingsDetailsStyle } from './style/BriefingsDetailsStyle';
import QuestionTitle from '../QuestionTitle';
import MoldalFooter from '../MoldalFooter';

import { ContentTitle } from '../../utilities/styledComponents/ContentTitle';
import { buildQuestionsAndAnswers } from '../../../services/briefing/details';

export default class BriefingDetails extends Component {
	state = {
		apiResponseData: [],
		dataStep: [],
		titleStep: '',
		step: 4,
	};

	componentDidMount() {
		const { step } = this.state;
		const { match } = this.props;

		this.getStepFromApi(match.params.briefingId, step);
	}

	nextStep = () => {
		let { step } = this.state;
		const { match } = this.props;
		step += 1;

		if (step >= 10) {
			step = 10;
		}

		this.setState({ step });

		this.getStepFromApi(match.params.briefingId, step);
		window.scrollTo(0, 80);
	};

	previousStep = () => {
		let { step } = this.state;
		const { match } = this.props;

		step -= 1;

		if (step <= 1) {
			useHistoryPush('/briefings');
		}

		window.scrollTo(0, 80);
		this.setState({ step });
		return this.getStepFromApi(match.params.briefingId, step);
	};

	goToStep = (step) => {
		const { match } = this.props;
		this.setState({ step });
		this.getStepFromApi(match.params.briefingId, step);
	};

	getStepFromApi = (briefingId, stepId) => {
		api.get(`/briefings/${briefingId}/steps/${stepId}?details=true`)
			.then((response) => {
				this.setState({
					apiResponseData: response.data.data,
				}, this.filterResponseApi);
			});
	};

	filterResponseApi = () => {
		const { apiResponseData } = this.state;
		const titleStep = apiResponseData.relationships.step.attributes.title;

		this.setState({ titleStep });

		const questions = buildQuestionsAndAnswers(apiResponseData);

		return this.setState({ dataStep: questions });
	};

	render() {
		const {
			dataStep, titleStep, step, apiResponseData,
		} = this.state;

		return (
			<BriefingsDetailsStyle>
				<section className="component-briefing">

					<div className="content-briefings-details">
						<ContentTitle>Bem-vindo ao Gearbox</ContentTitle>

						<div className="container-begin-briefing">
							<div className="container-fluid">
								<div className="row">
									<div className="col-12">
										<a href="./briefings" className="back-briefings">{'< Voltar para meus briefings'}</a>
									</div>
								</div>

								<div className="box-content">
									<div className="row">
										<div className="col-12">
											<div className="box-title">
												<img src={checkForm} alt="ícone formulário" className="icon-form" />
												<h3>
													{apiResponseData.attributes
														? apiResponseData.attributes.pre_sale_id
														: null}
												</h3>
											</div>
										</div>
									</div>

									<img src={`/images/status/mobile/${step}.svg`} className="w-100 mb-5 status" alt={`status${step}`} />

									<svg x="0px" y="0px" viewBox="0 0 875.52 100.8" className="status-briefing">
										<g id="line">
											<rect x="32.08" y="36.34" className="st4" width="793.21" height="1.92" />
										</g>
										<g id="circle1" onClick={this.goToStep.bind(this, 4)}>
											<circle className="st4" cx="48.65" cy="37.3" r="17.71" />
											<text transform="matrix(1 0 0 1 28.3126 70.6487)">
												<tspan x="0" y="0" className="st5 st6 st3">PLANO</tspan>
												<tspan x="-21.66" y="14.4" className="st5 st6 st3">CONTRATADO</tspan>
											</text>
											<text
												transform="matrix(1 0 0 1 42.6997 44.6435)"
												className="st7 st2 st8 content-text"
											>1
											</text>
										</g>
										<g id="circle2" onClick={this.goToStep.bind(this, 5)}>
											<circle className="st4" cx="177.36" cy="37.44" r="17.57" />
											<text
												transform="matrix(1 0 0 1 172.4312 44.4496)"
												className="st7 st2 st9 content-text"
											>2
											</text>
											<text transform="matrix(1 0 0 1 121.0164 70.6485)">
												<tspan x="0" y="0" className="st10 st6 st3">CARACTERÍSTICAS</tspan>
												<tspan x="17" y="14.4" className="st10 st6 st3">DE ESTOQUE</tspan>
											</text>
										</g>
										<g id="circle3" onClick={this.goToStep.bind(this, 6)}>
											<circle className="st4" cx="306.96" cy="37.44" r="17.57" />
											<text
												transform="matrix(1 0 0 1 301.5469 44.1723)"
												className="st7 st2 st11 content-text"
											>3
											</text>
											<polygon
												className="st12"
												points="301.13,62.69 288.5,62.69 288.5,62.69 301.13,62.69 	"
											/>
											<text transform="matrix(1 0 0 1 282.5154 70.6487)">
												<tspan x="0" y="0" className="st10 st6 st3">OBJETIVO</tspan>
												<tspan x="-14.33" y="14.4" className="st10 st6 st3">DA CAMPANHA</tspan>
											</text>
										</g>
										<g id="circle4" onClick={this.goToStep.bind(this, 7)}>
											<circle className="st4" cx="436.11" cy="37.09" r="17.5" />
											<text
												transform="matrix(1 0 0 1 429.1719 44.2646)"
												className="st7 st2 st13 content-text"
											>4
											</text>
											<text transform="matrix(1 0 0 1 407.7675 72.2914)">
												<tspan x="0" y="0" className="st10 st6 st3">ALCANCE</tspan>
												<tspan x="-15.67" y="14.4" className="st10 st6 st3">DA CAMPANHA</tspan>
											</text>
										</g>
										<g id="circle5" onClick={this.goToStep.bind(this, 8)}>
											<circle className="st4" cx="565.54" cy="37.3" r="17.71" />
											<text
												transform="matrix(1 0 0 1 559.9199 44.3168)"
												className="st7 st2 st14 content-text"
											>5
											</text>
											<text transform="matrix(1 0 0 1 523.3463 70.649)">
												<tspan x="0" y="0" className="st10 st6 st3">SEGMENTAÇÃO</tspan>
												<tspan x="2.67" y="14.4" className="st10 st6 st3">DA CAMPANHA</tspan>
											</text>
										</g>
										<g id="circle6" onClick={this.goToStep.bind(this, 9)}>
											<circle className="st4" cx="695.52" cy="37.3" r="17.71" />
											<text
												transform="matrix(0.9431 0 0 1 690.1747 44.6435)"
												className="st7 st2 st15 content-text"
											>6
											</text>
											<text transform="matrix(1 0 0 1 678.5852 70.6485)">
												<tspan x="0" y="0" className="st10 st6 st3">PEÇA</tspan>
												<tspan x="-10.33" y="14.4" className="st10 st6 st3">GRÁFICA</tspan>
											</text>
										</g>
										<g id="circle7" onClick={this.goToStep.bind(this, 10)}>
											<circle className="st4" cx="825.29" cy="37.09" r="17.5" />
											<text
												transform="matrix(0.9874 0 0 1 820.1973 44.6435)"
												className="st7 st2 st16 content-text"
											>7
											</text>
											<text transform="matrix(1 0 0 1 787.0217 72.2917)">
												<tspan x="0" y="0" className="st10 st6 st3">FINALIZANDO</tspan>
												<tspan x="5" y="14.4" className="st10 st6 st3">O BRIEFING</tspan>
											</text>
										</g>
									</svg>

									<div className="row">
										<div className="col-12">
											<div className="content-briefing my-0">
												<QuestionTitle titleStep={titleStep} />

												<div className="general">
													{ dataStep.map((question) => {
														if (question.answer && question.answer !== 'Vazio') {
															return (
																<Fragment>
																	<div className="question">
																		<p className="title">{ ReactHtmlParser(question.title) }</p>
																		<p className="text">{question.answer}</p>
																	</div>

																	<hr />
																</Fragment>
															);
														}

														return '';
													}) }
												</div>

												<div className="group-buttons mb-5">
													<button
														type="button"
														className={`btn btn-light ${step === 10 ? 'm-auto' : ''} ${step <= 4 ? 'd-none' : 'd-block'}`}
														onClick={this.previousStep}
													>
														Voltar
													</button>

													<button
														type="button"
														className={`btn btn-success btn-no-border ${step === 10 ? 'd-none' : 'd-block'} ${step <= 4 ? 'm-auto' : ''}`}
														onClick={this.nextStep}
													>
														Próximo
													</button>
												</div>
											</div>
										</div>
									</div>

									<div className="row">
										<div className="col-12">
											<MoldalFooter />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</BriefingsDetailsStyle>
		);
	}
}
